import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { FeatureToggles } from "utils/FeatureToggles";

/**
 * Utility function to determine if the current route is on the broker (dashboard) side
 *
 * @returns {boolean} true if current route contains '/dashboard'
 */
export var isBrokerSide = function isBrokerSide() {
  var _context;
  if (typeof window === "undefined") {
    return false;
  }
  return _includesInstanceProperty(_context = window.location.pathname).call(_context, "/dashboard");
};

/**
 * Utility function to determine if the current route is on the client side
 *
 * @returns {boolean} true if current route does not contain '/dashboard'
 */
export var isClientSide = function isClientSide() {
  return !isBrokerSide();
};

/**
 * Broker app basename. The broker app uses <BrowserRouter basename="/dashboard">,
 * so paths passed to React Router (Link, history.push) should NOT include this prefix—
 * the router adds it. Use getBrokerLeaseDetailsFullPath only for raw <a href> so the
 * browser gets the full path.
 */
export var BROKER_APP_BASENAME = "/dashboard";

/**
 * Broker lease details path (company context), without basename.
 * Use with React Router (Link, history.push) in the broker app—the router prepends BROKER_APP_BASENAME.
 * Returns "" if organizationId or leaseId is missing so callers can avoid rendering invalid links.
 */
export var getBrokerLeaseDetailsPath = function getBrokerLeaseDetailsPath(organizationId, leaseId) {
  var _context2;
  if (!organizationId || !leaseId) return "";
  return _concatInstanceProperty(_context2 = "/company/".concat(organizationId, "/leases/")).call(_context2, leaseId, "/details");
};

/**
 * Full broker lease details path including basename.
 * Use for raw <a href> (e.g. SubleaseDetails) so the URL is correct when the broker app is at /dashboard.
 * Returns "" if organizationId or leaseId is missing.
 */
export var getBrokerLeaseDetailsFullPath = function getBrokerLeaseDetailsFullPath(organizationId, leaseId) {
  var _context3;
  var path = getBrokerLeaseDetailsPath(organizationId, leaseId);
  return path ? _concatInstanceProperty(_context3 = "".concat(BROKER_APP_BASENAME)).call(_context3, path) : "";
};

/**
 * Client lease details path (portfolio management).
 * Use for links from client views (e.g. transaction table when clientSide).
 * Returns "" if organizationId or leaseId is missing.
 */
export var getClientLeaseDetailsPath = function getClientLeaseDetailsPath(organizationId, leaseId) {
  var _context4;
  if (!organizationId || !leaseId) return "";
  return _concatInstanceProperty(_context4 = "/".concat(organizationId, "/portfoliomanagement/lease/")).call(_context4, leaseId, "/lease_details");
};

/**
 * Client-app path to one tab of a transaction, e.g. `/org-1/dealroom/deal-1/listings`. Omit `tab`
 * for the transaction root.
 */
export var getClientDealroomPath = function getClientDealroomPath(organizationId, dealroomId, tab) {
  var _context5, _context6;
  var root = _concatInstanceProperty(_context5 = "/".concat(organizationId, "/dealroom/")).call(_context5, dealroomId);
  return tab ? _concatInstanceProperty(_context6 = "".concat(root, "/")).call(_context6, tab) : root;
};

/**
 * Client-app URL when a broker previews an organization without a dealroom context
 * (e.g. company Transactions tab). Matches ClientRouter landing ("/" → "workplaceos").
 */
export var getBrokerClientViewOrganizationPath = function getBrokerClientViewOrganizationPath(organizationId) {
  if (FeatureToggles.WORKPLACE_OS) {
    return "/".concat(organizationId, "/workplaceos");
  }
  return "/".concat(organizationId, "/");
};